module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MATHEMATICS-e7ab0b0c599c525a969974e0566c69dc.png";